import { useTranslation } from 'react-i18next'
import { useMutation } from '@tanstack/react-query'
import { useSubmitQueue } from 'hooks/useSubmitQueue'
import { submitDynamicDocuments } from 'services/DynamicFieldsService'
import { DynamicDocumentPayload } from 'types/dynamicFields'

export const useDynamicDocumentsMutation = () => {
  const { t } = useTranslation()
  const { submitQueue } = useSubmitQueue()

  return useMutation({
    mutationFn: (documents: DynamicDocumentPayload[]) =>
      submitQueue({
        payloadArray: documents,
        service: submitDynamicDocuments,
        successToastMessage: t('uploadDocument.fileUploadSuccess'),
        errorToastMessage: t('uploadDocument.fileUploadError'),
      }),
  })
}
